export const PUBLIC_SIGNUP_PATH = "/signup/invite";

export const SIGNUP_INVITE_RETURN_KEY = "wm_signup_invite_return";

export const isPublicSignupPath = (pathname = window.location.pathname) =>
  pathname === PUBLIC_SIGNUP_PATH || pathname.startsWith(`${PUBLIC_SIGNUP_PATH}/`);

export const clearSignupInviteReturnUrl = () => {
  if (typeof sessionStorage === "undefined") {
    return;
  }
  sessionStorage.removeItem(SIGNUP_INVITE_RETURN_KEY);
};

export const resumeSignupInviteAfterSignOut = () => {
  if (typeof window === "undefined" || typeof sessionStorage === "undefined") {
    return false;
  }
  const raw = sessionStorage.getItem(SIGNUP_INVITE_RETURN_KEY);
  if (!raw) {
    return false;
  }
  try {
    const target = new URL(raw);
    const current = new URL(window.location.href);
    if (target.origin !== current.origin) {
      sessionStorage.removeItem(SIGNUP_INVITE_RETURN_KEY);
      return false;
    }
    if (target.href !== current.href) {
      window.location.replace(target.href);
      return true;
    }
    sessionStorage.removeItem(SIGNUP_INVITE_RETURN_KEY);
  } catch {
    sessionStorage.removeItem(SIGNUP_INVITE_RETURN_KEY);
  }
  return false;
};

export const getPublicSignupSignOutUrl = ({
  origin = typeof window !== "undefined" ? window.location.origin : "",
  pathname = typeof window !== "undefined" ? window.location.pathname : PUBLIC_SIGNUP_PATH,
  search = typeof window !== "undefined" ? window.location.search : "",
} = {}) => `${origin}${pathname}${search}`;
